<template>
  <div class="page">
    <!-- header -->
    <xh-header />

    <!-- banner -->
    <!-- <ny-banner /> -->

    <div class="ny-tabs">
      <ul>
        <li
          v-for="child in subTypes" :key="child.id"
          :class="{'action': subType === child.subType}"
          @click="tabClick(child)"
        >
          {{ child.name }}
          <span v-if="child.list.length">({{ child.list.length }})</span>
        </li>
      </ul>
    </div>

    <div class="container-width">
      <div class="search-txt" v-if="queryString">
        {{ queryString }}
      </div>
      <div class="search-box">
        <input placeholder="搜索"
          @keyup.enter="searchHandle"
          type="text" v-model="phoneQuery" />
      </div>
      <div class="new-list" v-if="showList.length">
        <dl v-for="item in showList" :key="item.id">
          <dt class="mouse" @click="dumpLink(item.id)">
            <!-- <span class="new"></span> -->
            <img width="388" height="250" :src="item.cover" :alt="item.title">
          </dt>
          <dd>
            <h3 class="mouse" @click="dumpLink(item.id)">{{ item.title }}</h3>
            <div>
              {{ item.createTime ? formatDate(Date.parse(item.createTime)) : '' }}
            </div>
            <div class="content">
              {{ item.introduction }}
            </div>
            <span class="detail" @click="$router.push(`/notice/detail?id=${type}-${subType}-${item.id}`)">查看详情</span>
          </dd>
        </dl>

      </div>
      <div class="pagination-box" v-if="showList.length">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
      <div class="no-found" v-if="queryString && !showList.length">
        没有找到关键字为"<span class="red">{{ queryString }}</span>"的文章
      </div>
    </div>

    <!-- footer -->
    <xh-footer />
  </div>
</template>
<script>
import XhHeader from '../../reveals/xh-header.vue'
import XhFooter from '../../reveals/xh-footer.vue'
import NyBanner from '../../sections/ny-banner.vue'
import { wenzhang } from '@/page/constants'
import { getNewsPage } from '@/service/apis/news'
let subTypes = []
wenzhang.forEach(item => {
  let children = item.children
  for (let i = 0 ; i < children.length; i ++) {
    let child = children[i]
    child.pageIndex = 1
    child.pageSize = 10
    child.total = 0
    child.list = []
    child.type = item.id // type
    child.subType = children[i].id // subType

    subTypes.push(child)
  }
})

export default {
  components: {
    XhHeader,
    XhFooter,
    NyBanner
  },
  name: 'Search',
  data () {
    return {
      type: 1, // 协会公告
      subType: 11, // 赛事活动
      subTypes,
      queryString: '',
      phoneQuery: '',
      list: []
    }
  },
  computed: {
    showList () {
      let find = this.subTypes.find(item => item.id === this.subType)
      // this.subTypes[this.subType].list
      return find.list || []
    },
    pagination () {
      let find = this.subTypes.find(item => item.id === this.subType)
      return {
        pageSize: find.pageSize,
        total: find.total
      }
    }
  },
  watch: {
    '$route.query.type'(val) {
      this.queryString = val
      this.getList()
    }
  },
  created() {
    // if ()
    let queryString = this.$route.query.type
    if (queryString) {
      this.queryString = queryString
      this.getList()
    }
  },
  methods: {
    searchHandle () {
      this.queryString = this.phoneQuery
      this.getList()
    },
    dumpLink (id) {
      // 协会公告
      if (this.type === 1) {
        this.$router.push(`/notice/detail?id=${this.type}-${this.subType}-${id}`)
      } else { // 新闻
        this.$router.push(`/news/detail?id=${this.type}-${this.subType}-${id}`)
      }
    },
    tabClick (menu) {
      this.type = menu.type
      this.subType = menu.subType

    },
    currentChange (page) {
      let findIndex = this.subTypes.find(item => item.id === this.subType)
      if (findIndex >=0 ) {
        this.subTypes[findIndex].pageIndex = page
        this.fetchList(findIndex)
      }
    },
    getList () {
      for (let i = 0; i < this.subTypes.length; i++) {
        this.fetchList(i)
      }
    },
    fetchList (index) {
      let type = this.subTypes[index]
      let opt = {
        pageIndex: type.pageIndex,
        pageSize: type.pageSize,
        type: type.type,
        subType: type.subType,
        queryString: this.queryString
      }
      getNewsPage.call(this, opt).then(res => {
        let data = res.data
        this.subTypes[index].total = data.total || 0
        this.subTypes[index].list = []
        if (data.records && data.records.length) {
          data.records.forEach(item => {
            this.subTypes[index].list.push(item)
          })
        }
      })
    }
  },
}
</script>
<style scoped>

.red {
  color: #c61313;
}

.search-txt {
  margin: 24px auto 12px auto;
  font-size: 20px;
  line-height: 44px;
  color: #888;
  border-radius: 6px;
  text-align: center;
  width: 50%;
  background-color: #eee;
}

.search-box {
  display: none;
}
@media screen and (max-width: 736px) {
  .new-list dl {
    margin: 6px 0;
  }
  .new-list dl dt {
    display: none;
  }
  .new-list dl dd {
    width: 100%;
    padding: 12px;
  }

  .new-list dl dd h3 {
    padding-top: 0;
  }
  .search-txt {display: none;}
  .search-box {
    display: block;
  }
  .search-box input {
    padding: 0 12px;
    box-sizing: border-box;
    margin-top: 22px;
    height: 36px;
    line-height: 36px;
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 6px;
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4c2ac9;
}
.no-found {
  text-align: center;
  font-size: 16px;
  color: #666;
  line-height: 120px;
  min-height: 260px;
}
.ny-tabs ul li span {
  font-size: 14px;
  color: #c61313;
}

.ny-tabs ul li.action::after {
  bottom: -1px;
}
</style>
